import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AddClient from '../components/new/addClient';
import './Clienti.css';

const API_URL =
  'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getClients';
const SEARCH_API_URL =
  'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/searchClient';

export default function Clienti() {
  const navigate = useNavigate();

  const [clienti, setClienti] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState('');
  const [isAddClientOpen, setIsAddClientOpen] = useState(false);

  useEffect(() => {
    getClienti();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (search.trim()) {
        searchClienti(search.trim());
      } else {
        getClienti();
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [search]);

  async function getClienti() {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      setClienti(
        data.clienti || data.clients || (Array.isArray(data) ? data : [])
      );
    } catch (err) {
      setError('Nu am putut încărca lista de clienți.');
    } finally {
      setLoading(false);
    }
  }

  async function searchClienti(value) {
    setSearching(true);
    setError('');
    try {
      const res = await fetch(
        `${SEARCH_API_URL}?q=${encodeURIComponent(value)}`
      );
      const data = await res.json();
      setClienti(
        data.clienti || data.clients || (Array.isArray(data) ? data : [])
      );
    } catch (err) {
      setError('Nu am putut căuta clienții.');
    } finally {
      setSearching(false);
      setLoading(false);
    }
  }

  function openAddClientModal() {
    setIsAddClientOpen(true);
  }

  function closeAddClientModal() {
    setIsAddClientOpen(false);
  }

  async function onClientSaved() {
    await getClienti();
    setIsAddClientOpen(false);
  }

  function createClientSlug(name) {
    return (name || '').trim().replace(/\s+/g, '-');
  }

  function openClient(client) {
    navigate(`/clienti/${createClientSlug(client.nume)}`);
  }

  function getLogoContent(client) {
    if (client.logo) {
      return <img src={client.logo} alt={client.nume} />;
    }
    return <span>{client.nume?.charAt(0) || '?'}</span>;
  }

  return (
    <section className="clientiPage">
      <div className="clientiHeader">
        <div>
          <h1>Clienți</h1>
        </div>
        <button
          type="button"
          className="addClientButton"
          onClick={openAddClientModal}
        >
          + Adaugă client
        </button>
      </div>

      <div className="clientiSearch">
        <span>⌕</span>
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Escape') setSearch('');
          }}
          placeholder="Caută după nume client sau CUI..."
        />
        {search && (
          <button
            type="button"
            className="searchClearButton"
            onClick={() => setSearch('')}
          >
            ×
          </button>
        )}
      </div>

      {loading && (
        <div className="clientiMessage">Se încarcă lista de clienți...</div>
      )}

      {error && <div className="clientiError">{error}</div>}

      {!loading && !error && (
        <div className="clientiList">
          {searching && (
            <div className="clientiMessage">Se caută...</div>
          )}
          {!searching && clienti.length === 0 && (
            <div className="clientiMessage">
              Nu există clienți pentru această căutare.
            </div>
          )}
          {!searching &&
            clienti.map((client) => (
              <button
                type="button"
                className="clientCard"
                key={client.id}
                onClick={() => openClient(client)}
              >
                <div className="clientLogo">{getLogoContent(client)}</div>
                <div className="clientInfo">
                  <h2>{client.nume}</h2>
                  <p>{client.cui || 'CUI lipsă'}</p>
                </div>
                <div className="clientStats">
                  <div>{client.comenziInCurs || 0} comenzi în curs</div>
                  <div>{client.comenziTotale || 0} comenzi totale</div>
                </div>
                <div className="clientArrow">›</div>
              </button>
            ))}
        </div>
      )}

      <AddClient
        isOpen={isAddClientOpen}
        mode="new"
        onClose={closeAddClientModal}
        onSaved={onClientSaved}
      />
    </section>
  );
}
